export default "__VITE_ASSET__hTWnE0DO__"